import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import qs from 'qs';
import { ForgotPassword } from './pages/Password/ForgotPassword';
import { ResetPassword } from './pages/Password/ResetPassword';

import { LogIn } from './pages/Auth/LogIn';
import { SignUp } from './pages/Auth/SignUp';
import { MatchRouter } from './pages/Match/MatchRouter';

import { paths } from './paths';
import { TeamProvider } from './contexts/TeamContext';
import { ReferralLanding } from './pages/Referrals/ReferralLanding';
import { MatchActivity } from './pages/Activities/MatchActivity';

export const UnauthenticatedApp: React.FC = () => {
  return (
    <TeamProvider>
      <Switch>
        <Route
          path="/"
          exact={true}
          render={() => <Redirect to={paths.signIn()} />}
        />
        <Route path={paths.signIn()} exact={true} component={LogIn} />
        <Route
          path={paths.referrals.redeem()}
          exact={true}
          component={ReferralLanding}
        />
        <Route path="/sign-up" exact={true} component={SignUp} />
        <Route
          path={paths.password.forgot()}
          exact={true}
          component={ForgotPassword}
        />
        <Route
          path={paths.password.reset()}
          exact={true}
          component={ResetPassword}
        />
        <Route path={paths.match.home()} component={MatchRouter} />
        <Route
          exact={true}
          component={MatchActivity}
          path={paths.activities.home()}
        />
        <Route
          render={({ location }) => {
            console.log(`${location.pathname}${location.search}`);
            const query = qs.stringify({
              intended: `${location.pathname}${location.search}`,
            });

            return <Redirect to={`${paths.signIn()}?${query}`} />;
          }}
        />
      </Switch>
    </TeamProvider>
  );
};
